__webpack_require__.p = "https://mf-platform.pages.dev/";